/* global axios */
import ApiClient from '../ApiClient';

class AilabDocument extends ApiClient {
  constructor() {
    super('ailab/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId, status } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
        assistant_id: assistantId,
        status,
      },
    });
  }

  retry(id) {
    return axios.post(`${this.url}/${id}/retry`);
  }

  metrics({ hours = 24 } = {}) {
    return axios.get(`${this.url}/metrics`, { params: { hours } });
  }
}

export default new AilabDocument();
